import { useState, useEffect, useCallback } from "react";
import { listCrew, getCrewAvailability, createCrew, updateCrew, deleteCrew } from "@/lib/api";
import { toast } from "sonner";

export function useCrewData(dateStart, dateEnd) {
  const [crew, setCrew] = useState([]);
  const [loading, setLoading] = useState(true);
  const hasDateRange = dateStart && dateEnd;

  const fetchCrew = useCallback(async () => {
    try {
      // Always use the availability endpoint — it correctly computes
      // "booked" from event assignments when dates are provided,
      // and returns "available" (unless manually "unavailable") when no dates
      const res = await getCrewAvailability(dateStart, dateEnd);
      setCrew(res.data);
    } catch {
      toast.error("Failed to load crew");
    } finally {
      setLoading(false);
    }
  }, [dateStart, dateEnd]);

  useEffect(() => { fetchCrew(); }, [fetchCrew]);

  const handleCreate = async (form) => {
    await createCrew(form);
    toast.success("Crew added");
    fetchCrew();
  };

  const handleUpdate = async (crewId, form) => {
    await updateCrew(crewId, form);
    toast.success("Crew updated");
    fetchCrew();
  };

  const handleDelete = async (crewId) => {
    await deleteCrew(crewId);
    toast.success("Crew removed");
    fetchCrew();
  };

  return { crew, loading, hasDateRange, fetchCrew, handleCreate, handleUpdate, handleDelete };
}
